const organizations = {
    require_membership: 'ผู้ใช้จะต้องเป็นสมาชิกขององค์กรก่อนจึงจะดำเนินการต่อได้',
    role_names_not_found: 'ตรวจพบชื่อบทบาทที่ไม่ถูกต้อง: {{names,list(type:conjunction)}} กรุณาสร้างบทบาทเหล่านี้ก่อนจึงจะดำเนินการต่อได้',
};
export default Object.freeze(organizations);
